import { Link } from 'react-router-dom';
import { Notice } from '@verlo/shared/components/ui/notice';
import { Button } from '@verlo/shared/components/ui/button';
import { useSite, useHasTill } from '../contexts/SiteContext';

/**
 * Route guard for the till-shaped pages — live ops, the cash-ups, the service-mode
 * timeline, the typed extras, the Node page. A back-office site has no
 * Verlo on its floor, so these pages have nothing to show and never will until the
 * venue buys the front of house.
 *
 * It explains rather than redirects. The nav already hides these entries
 * (`till: true` in `areas.js`), so anyone arriving here came by a bookmark, a shared
 * link or a demo — bouncing them silently to the dashboard reads as a broken link,
 * where a sentence reads as a product boundary.
 */
const RequireTill = ({ children }) => {
  const { current } = useSite();
  const hasTill = useHasTill();
  // True while the site is still loading, so a full-plan venue never sees this flash on a
  // cold load.
  if (hasTill) return children;

  return (
    <div className="mx-auto max-w-prose px-4 py-10">
      <Notice
        tone="info"
        word="Front of house"
        title="This page needs Verlo on the floor"
        action={<Button asChild size="sm"><Link to="/back-office/front-of-house">Add the floor</Link></Button>}
      >
        {current.name} runs its back office on Verlo. Live service, cash-ups and the till
        health all come from a Verlo till, so there is nothing here yet. When the venue&rsquo;s
        till contract ends we can put Verlo on the floor too, and these pages fill in from
        the first service.
      </Notice>
    </div>
  );
};

export default RequireTill;
